import { useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { ConsumableMenu } from '../../components/consumables/ConsumableMenu'
import { MoveZone } from '../../components/zone/moveZone/MoveZone'
import { RaceTypes } from '../../enums/RaceTypes'
import { UserProfile } from '../../models/UserProfile'
import { areVehiclesEquals, Vehicle } from '../../models/Vehicle'
import { VehicleService } from '../../services/VehicleService'
import { Footer } from './footer/Footer'
import { Header } from './header/Header'
import './MainPage.css'
import { Roulette } from './roulette/Roulette'
import { VehicleInfo } from './vehicleInfo/VehicleInfo'
import { VehicleSpec } from './vehicleSpec/VehicleSpec'

export const MainPage = () => {

    const [selectedMode, setSelectedMode] = useState<RaceTypes>(RaceTypes.UNRANKED)
    const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null)
    const [profile, setProfile] = useState<UserProfile | null>(JSON.parse(localStorage.getItem('profile') || 'null'))

    useEffect(() => {
        if (!selectedVehicle) return
        if (!selectedVehicle?.id) return
        VehicleService.getVehicle(selectedVehicle.id)
            .then((vehicle) => {
                if (areVehiclesEquals(vehicle, selectedVehicle)) return
                setSelectedVehicle(vehicle)
            })
    }, [selectedVehicle])

    const handleModeChange = (mode: RaceTypes) => {
        setSelectedMode(mode)
    }

    useEffect(() => {
        setProfile(null)
    }, [])

    return (
        <>
            <div className="main-page">
                <Header
                    profile={profile}
                    setProfile={setProfile}
                    selectedMode={selectedMode}
                    selectedVehicle={selectedVehicle}
                    onModeChange={handleModeChange}
                    setSelectedVehicle={setSelectedVehicle}
                />
                {selectedVehicle && <MoveZone carId={selectedVehicle.id} />}
                {/* <Daily dailies={profile?.tasks as DailyTask[] || []} /> */}
                {selectedVehicle && <VehicleSpec modelName={selectedVehicle.modelName} />}
                {selectedVehicle && <ConsumableMenu selectedVehicle={selectedVehicle} />}
                {selectedVehicle && <VehicleInfo selectedVehicle={selectedVehicle} />}
                <Roulette selectedVehicle={selectedVehicle} setSelectedVehicle={setSelectedVehicle} />
                <Footer />
            </div>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    duration: 2000,
                }}
            />
        </>
    )
}

export default MainPage